import { FaceWomanOutlineIcon } from './FaceWomanOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F8B0D936-DFD2-469C-B671-599D3B277B51
 * name face-woman-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-woman-outline.svg
 * tags
 * - People / Family 
 */
export const EmojiWomanOutlineIcon = FaceWomanOutlineIcon;
export default EmojiWomanOutlineIcon